import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { IAppConfig, IEditableContent } from '../interfaces/IEditableContent';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config$: Observable<IAppConfig> | null = null;

  constructor(private http: HttpClient) {}

  /**
   * Load application configuration from config.json
   */
  public loadConfig$(): Observable<IAppConfig> {
    if (!this.config$) {
      this.config$ = this.http.get<IAppConfig>('assets/config.json').pipe(
        catchError((error) => {
          console.error('Error loading config.json:', error);
          // Return a default config if loading fails
          return of({
            currentData: '',
            historicData: '',
            appInsights: {
              instrumentationKey: '',
            },
          });
        }),
        shareReplay(1) // Cache the result
      );
    }
    return this.config$;
  }

  /**
   * Get editable content for LC summary page
   */
  public getLCSummaryEditableContent$(): Observable<IEditableContent | null> {
    return this.loadConfig$().pipe(
      map((config) => config.editableContent?.lcSummary || null)
    );
  }
}
